var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIconYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 132,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.277 39.798c0-19.896 16.13-36.025 36.025-36.025h52.4c19.896 0 36.025 16.13 36.025 36.025v52.4c0 19.896-16.129 36.025-36.025 36.025h-52.4c-19.896 0-36.025-16.129-36.025-36.025v-52.4z",
    stroke: "#F9B035",
    strokeWidth: 6.55
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 34,
    width: 64,
    height: 64
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.167 34.65H32.465v62.702h62.702V34.65z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.303 97.352V69.485h8.957l2.24-11.612H68.302V53.23c0-4.645 2.243-6.967 6.718-6.967h4.478V34.65h-8.957c-8.23 0-13.436 6.69-13.436 16.257v6.966h-8.958v11.612h8.958v27.867h11.197z",
    fill: "#F9B035",
    stroke: "#F9B035",
    strokeWidth: 3.275
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIconYellow);
export default __webpack_public_path__ + "static/media/facebook-icon-yellow.1713560263cdfe66d0c769e0ca98e598.svg";
export { ForwardRef as ReactComponent };